export const BALANCE_POLL_INTERVAL_MS = 1000;
export const BALANCE_POLL_LIMIT_MS = 10_000;

interface ShouldPollBalanceInput {
    /** The balance the success screen opened with — the one fetched before the purchase. */
    baseline: number;
    current: number;
    elapsedMs: number;
    isProgramActive: boolean;
}

/**
 * Whether the success screen asks for the loyalty balance again (SWRN-2271).
 *
 * The purchase point lands about 0.3–0.5 s after status 3 (SWRN-2227), usually
 * after the screen's first balance request, so the screen keeps asking until the
 * balance moves. A purchase that earns nothing — paid with points, or below the
 * program's minimum price — never moves it, which is why the limit is short and
 * the stop is silent.
 */
export const shouldPollBalance = ({
    baseline,
    current,
    elapsedMs,
    isProgramActive,
}: ShouldPollBalanceInput): boolean =>
    isProgramActive &&
    current === baseline &&
    // The tick this would schedule, so the last request stays inside the limit.
    elapsedMs + BALANCE_POLL_INTERVAL_MS < BALANCE_POLL_LIMIT_MS;
